/** @file pickJoint: the joint under a screen point (nearest within a radius; the nearer one wins ties). */
import type { ScreenJoint } from './projectJoints';

/** Distances closer than this count as a tie (stacked joints). */
const TIE_PX = 0.5;

/**
 * The joint nearest `(x, y)` within `radiusPx` target pixels; when two lie within `TIE_PX` of the same distance the
 * one nearer the camera (smaller depth) wins. Null when none is in reach.
 */
export function pickJoint(points: readonly ScreenJoint[], x: number, y: number, radiusPx = 8): ScreenJoint | null {
  let best: { joint: ScreenJoint; d: number } | null = null;
  for (const joint of points) {
    const d = Math.hypot(joint.x - x, joint.y - y);
    if (d > radiusPx) continue;
    const tie = best !== null && Math.abs(d - best.d) <= TIE_PX;
    if (best === null || (tie ? joint.depth < best.joint.depth : d < best.d)) best = { joint, d };
  }
  return best?.joint ?? null;
}
